import React from 'react';
import {
  makeStyles,
  createMuiTheme,
  MuiThemeProvider,
  ThemeProvider,
} from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import PropTypes from 'prop-types';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

const muiTheme = createMuiTheme({
  overrides: {
    MuiSvgIcon: {
      root: {
        color: 'inherit',
      },
    },
  },
});

const useStyles = makeStyles((theme) => ({
  backgroundColor: '#f2f4f7',
  appBar: {
    position: 'relative',
    backgroundColor: '#9d5fbe',
    marginBottom: '20px',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const FullScreenDialog = (props) => {
  const {
    isOpen,
    toggleDialog,
    title,
    children,
    multipleDialogs,
    toggleBackDialog,
  } = props;
  const classes = useStyles();

  const handleClose = () => {
    toggleDialog();
  };

  const handleBack = () => {
    if (toggleBackDialog) {
      toggleBackDialog();
    }
  };

  return (
    <MuiThemeProvider theme={muiTheme}>
      <ThemeProvider theme={muiTheme}>
        <>
          <Dialog
            fullScreen
            open={isOpen}
            onClose={handleClose}
            TransitionComponent={Transition}
            scroll="body"
            PaperProps={{
              style: {
                backgroundColor: '#f2f4f7',
                color: 'black',
              },
            }}
          >
            <AppBar className={classes.appBar} id="topo">
              <Toolbar>
                {multipleDialogs ? (
                  <IconButton
                    edge="start"
                    color="inherit"
                    onClick={handleBack}
                    aria-label="back"
                  >
                    <ArrowBackIcon />
                  </IconButton>
                ) : null}

                <Typography variant="h6" className={classes.title}>
                  {title}
                </Typography>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={handleClose}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
              </Toolbar>
            </AppBar>
            <div className="theme-light">{children}</div>
          </Dialog>
        </>
      </ThemeProvider>
    </MuiThemeProvider>
  );
};

FullScreenDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  toggleBackDialog: PropTypes.func,
  title: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
  multipleDialogs: PropTypes.bool,
};

FullScreenDialog.defaultProps = {
  multipleDialogs: false,
  toggleBackDialog: null,
};

export default FullScreenDialog;
